import { FC } from 'react'
import { SvgProps } from './svgProps'

const FreeShippingBigIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 30}
    height={height || 30}
    viewBox="0 0 30 30"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path
            d="M0 0H30V30H0z"
            transform="translate(-357.000000, -228.000000) translate(357.000000, 228.000000)"
          />
          <g
            stroke={color || '#000'}
            strokeLinecap="round"
            strokeWidth="2"
            transform="translate(-357.000000, -228.000000) translate(357.000000, 228.000000) translate(2.000000, 2.000000)"
          >
            <circle cx="6" cy="23" r="3" />
            <circle cx="20" cy="23" r="3" />
            <path d="M19 8h3.646c.818 0 1.553.498 1.857 1.257l1.354 3.385c.094.237.143.489.143.743V20c0 1.105-.895 2-2 2h-1 0M0 16V3c0-1.657 1.343-3 3-3h13c1.657 0 3 1.343 3 3v10c0 1.657-1.343 3-3 3H0h0v4c0 1.105.895 2 2 2h1M9 22L17 22" />
            <path d="M7 8.5l1.425 1.425c.04.04.103.04.142 0l.004-.003L13 5h0" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default FreeShippingBigIcon
